import i18n from "../i18n";

/**
 * Re-runs Formik validation when i18n language changes so Yup error messages
 * match the active locale immediately.
 */
export function subscribeFormikLanguageRevalidation(componentInstance, formikRef) {
  const handler = lng => {
    componentInstance.setState({ i18nLanguage: lng }, () => {
      formikRef.current?.validateForm?.();
    });
  };

  i18n.on("languageChanged", handler);
  return () => i18n.off("languageChanged", handler);
}
